
import { useState } from "react";
import TopSection from "../../LT/TopSection";
import Cards from "../../../components/common/card/Card";

const Reporting = () => {
  const [activeItem, setActiveItem] = useState(localStorage.getItem("reportsActiveItem") || "1");
  const cardData = [
    { title: "1" },
    { title: "2" },
    { title: "3" },
  ];
  const callBackFunction = (index, title, url) => {
    setActiveItem(title);
    localStorage.setItem("reportsActiveItem", title)
  }
  return (
    <div>
      <TopSection
        labelList={[
          { title: "Home", path: "/dashboard" },
          { title: "Reports" },
        ]}
        tabTitle="Reports"
      />
      <div className="container">
        <Cards cards={cardData} showBorder={true} callBackFunction={callBackFunction} />
      </div>

    </div>
  )
}

export default Reporting;